import React from 'react';

// Required to use React.memo with a components using generics
// https://stackoverflow.com/questions/60386614/how-to-use-props-with-generics-with-react-memo/60386939#60386939
export const typedMemo: <T>(component: T) => T = React.memo;
